import { useQuery } from '@tanstack/react-query'
import { getProductDetaillService } from 'redux/services/productsServices'
import { QUERY_KEYS } from 'Utils/queryKeys'

export const useProductDetails = (
  { productId, companyId, warehouse },
  enabled = true
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PRODUCT_DETAIL, productId, warehouse],
    queryFn: async () => {
      const payload = {
        CompanyId: companyId,
        WarehouseId: warehouse,
        ProductId: productId,
        GlobalExecution: true,
        PriceListId: null,
      }

      const response = await getProductDetaillService(payload)
      const data = response?.data?.[0]
      if (!data) throw new Error('No product data found')
      return data
    },
    enabled,
    staleTime: 1000 * 60 * 60 * 8,
    cacheTime: 1000 * 60 * 60 * 8,
  })
}
